export interface PackageBreakdown {
  /** Whole packages, e.g. 14 Box. */
  packages: number;
  /** Components left over from the partial package, e.g. 2 Bag. */
  components: number;
}

/** Splits a package quantity with a partial (14.5 Box at 4 Bag per Box) into 14 Box + 2 Bag. */
export function packageBreakdown(quantity: number | null | undefined, componentsPerPackage: number | null | undefined): PackageBreakdown {
  const qty = quantity ?? 0;
  const packages = Math.trunc(qty);
  // Round away float noise: 14.3 - 14 is 0.3000000000000007.
  const components = Math.round((qty - packages) * (componentsPerPackage ?? 0) * 100) / 100;
  return { packages, components };
}
